import { useQuery } from '@tanstack/react-query';
import { getBatchProviderSchedules, getProviderSchedule } from '@uplift/api';
import * as batshit from '@yornaath/batshit';


const providerSchedules = batshit.create({
  fetcher: async (providerIds: string[]) => {
    const response = await getBatchProviderSchedules(providerIds);

    return response.data;
  },
  resolver: batshit.keyResolver('userId'),
  scheduler: batshit.windowScheduler(10)
});


export const useBatchableProviderScheduleQuery = (userId: string) => {
  return useQuery({
    cacheTime: 0,
    queryKey: [ 'provider', userId, 'schedule' ],
    queryFn: async () => {
      try {
        return providerSchedules.fetch(userId);
      } catch {
        return null;
      }
    }
  });
};


export const useProviderScheduleQuery = (userId: string) => {
  return useQuery({
    cacheTime: 0,
    queryKey: [ 'provider', userId, 'schedule' ],
    queryFn: async () => {
      try {
        const response = await getProviderSchedule(userId);

        return response.data;
      } catch {
        return null;
      }
    }
  });
};
